import { inOpenlegal } from '@/constants/platformNames'

export const OPENHEALTHCARE_COMPANY_NAME = 'OPENHEALTHCARE S.L.'
export const OPENLEGAL_COMPANY_NAME = 'OPENLEGAL S.L.'

export const OPENHEALTHCARE_COMPANY_ADDRESS = 'Avda. República Argentina 25 9ª planta, 41011 Sevilla'
export const OPENLEGAL_COMPANY_ADDRESS = 'C/ Puente Verde 4, 18008 Granada'

export const PRIVACY_POLICY_COMPANY_DATA =
	!inOpenlegal() ? {
		companyName: OPENHEALTHCARE_COMPANY_NAME,
		address: OPENHEALTHCARE_COMPANY_ADDRESS,
		platformName: 'Opensalud'
	} : {
		companyName: OPENLEGAL_COMPANY_NAME,
		address: OPENLEGAL_COMPANY_ADDRESS,
		platformName: 'Openlegal'
	}


// WEBPACK FOOTER //
// ./src/constants/companyCommonData.js